import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Marquee } from "@/components/Marquee";

export const Layout = ({ children, showMarquee = true }) => {
  const { member, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative">
      <div className="grain-overlay" />
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#070A0F]/85 border-b border-slate-800/80">
        <div className="max-w-md sm:max-w-lg md:max-w-2xl mx-auto px-4 py-3 flex items-center justify-between">
          <button
            onClick={() => navigate(member ? "/dashboard" : "/")}
            className="flex items-center gap-2.5 group"
            data-testid="brand-home-button"
          >
            <div className="w-8 h-8 rounded-full border border-emerald-500/40 flex items-center justify-center">
              <span className="font-serif-display text-emerald-400 text-lg leading-none">E</span>
            </div>
            <div className="text-left leading-none">
              <p className="font-serif-display text-base tracking-wide text-slate-100">EqhoSense</p>
              <p className="font-mono-ui text-[8px] uppercase tracking-[0.3em] text-slate-500 mt-0.5">Capital Markets</p>
            </div>
          </button>
          {member && (
            <button
              onClick={logout}
              data-testid="logout-button"
              className="flex items-center gap-1.5 text-slate-400 hover:text-slate-100 transition-colors font-mono-ui text-[10px] uppercase tracking-[0.2em]"
            >
              <LogOut className="w-3.5 h-3.5" /> Exit
            </button>
          )}
        </div>
      </header>
      {showMarquee && <Marquee />}
      <main className="relative z-10 max-w-md sm:max-w-lg md:max-w-2xl mx-auto px-4 py-8">{children}</main>
      <footer className="relative z-10 max-w-md sm:max-w-lg md:max-w-2xl mx-auto px-4 pb-10 pt-4">
        <p className="font-mono-ui text-[9px] leading-relaxed text-slate-600 tracking-wide">
          EqhoSense Capital Markets is a private member, introducer and verification portal. EqhoSense does not receive
          client funds, provide investment advice, guarantee returns, or approve investor participation. Final account
          approval is provided directly by the applicable regulated partner.
        </p>
      </footer>
    </div>
  );
};
